import { useEffect, useRef, useState } from "react";
import { Typography, Grid } from '@mui/material';
import { ExpansiblePanelPI } from "../Common/ExpansiblePanel";
import { UnauthorizedPage } from "../../pages/Error/ErrorUnauthorized";
import UsuarioService from "../../services/UsuarioService";
import { RolesInvUnidadDTO } from "../../interfaces/Usuarios/RolPersonaUnidadDTO";

interface Props{
    roles: Array<RolesInvUnidadDTO>,
    usuario: string,
    unidad: any,
    nombres: string;
    apellidos: string;
    autorizado: boolean;
}

const usuarioService = new UsuarioService();

export default function WebOmniProjectsComp(props:Props){
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const linkReporte = "https://app.powerbi.com/reportEmbed?reportId=f896bd86-8363-4879-bddb-ea12e464e13d&autoAuth=true&ctid=b7af8caf-83d8-4644-85ae-317c545223c1";
    const linkReporteByUnidad = "https://app.powerbi.com/reportEmbed?reportId=f896bd86-8363-4879-bddb-ea12e464e13d&autoAuth=true&pageName=0e639b474f470dd4827d&filter=T1_COLABORADORES%2FIDUNIDAD%20in%20%28{unidades}%29";
    const autoAuth="true";
    let enlaceAutoridadIframe = linkReporte;
    let enlaceDecanoIframe = linkReporte;
    let enlaceConsultorIframe = linkReporteByUnidad;
    let enlaceInvestigadorIframe = linkReporte;
    let [linkIf,setLinkIf] = useState('');

    const openLinkInNewTab = (link:string) => {
        const url = link; // Reemplaza esto con tu URL deseada
        window.open(url, '_blank');
    };

    function getRoles(roles:Array<RolesInvUnidadDTO>):string{
        let rol = "";
        //console.log(roles);
        if(usuarioService.authorizedByRol(145,roles) || usuarioService.authorizedByRol(150,roles) || usuarioService.authorizedByRol(144,roles) || usuarioService.authorizedByRol(151,roles)){
            rol = "AUTORIDAD"
        }else if(usuarioService.authorizedByRol(143,roles)){ //roles.includes("DECANO(A)")
            rol = "DECANO"
        }else if(usuarioService.authorizedByRol(147,roles)){ //roles.includes("DECANO(A)")}
            rol = "CONSULTOR"
        }
        else{
            rol = "INVESTIGADOR"
        }
        return rol;
    }

    function miEnlace(rol:string){
        switch(rol){
            case "AUTORIDAD":
                setLinkIf(enlaceAutoridadIframe);
                break;
            case "DECANO":
                setLinkIf(enlaceDecanoIframe);
                break;
            case "CONSULTOR":
                let unidades = usuarioService.unidadesByRol(147,props.roles);    
                const unidadesEnURL = unidades.map((id) => `%27${id}%27`).join('%2C');
                const urlFinal = linkReporteByUnidad.replace("{unidades}", unidadesEnURL);
                setLinkIf(urlFinal);
                break;
            default:
                setLinkIf(enlaceInvestigadorIframe);
                break;
        }
    }

    useEffect(() => {
        let rol = getRoles(props.roles);
        miEnlace(rol);
        //console.log(rol)
        //console.log(props.autorizado)
    },[props.autorizado]);
    
    return(
        <>
        {props.autorizado && (
            props.autorizado ?
            <>
            <Typography variant="h5" gutterBottom>
            <Grid container spacing={2}>
                <Grid item xs={10} sm={10} md={10} lg={10}>
                    Proyectos Decanato Investigación
                </Grid>
                <Grid item xs={2} sm={2} md={2} lg={2}>
                </Grid>         
            </Grid>
            </Typography>
            <ExpansiblePanelPI title="Antes de iniciar sesión" nombres={props.nombres} apellidos={props.apellidos} usuario={props.usuario} />
            <Grid container spacing={2} sx={{p:1}}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <iframe
                    ref={iframeRef} 
                    title='ReporteHistoriaEvaluaciones' 
                    style={{ width: '100%', height: '700px', border: 'none' }} 
                    src={linkIf}>
                    </iframe>
                </Grid>
            </Grid>
            </>
            :
            <UnauthorizedPage />)
        }
        {!props.autorizado && (
            <UnauthorizedPage />)
        }
        </>
    );
}